import { DeadLetterQueue } from '../../../../../services/eventingApi';
import { buttonClass, classNames } from '../shared/ui';
import DeadLetterMessages from './DeadLetterMessages';

interface QueueItemProps {
  queue: DeadLetterQueue;
  expanded: boolean;
  onToggle: () => void;
  onRedrive: () => void;
}

const QueueItem = ({ queue, expanded, onToggle, onRedrive }: QueueItemProps) => (
  <div className="rounded-md border border-gray-200 dark:border-gray-700">
    <div className="flex flex-wrap items-center justify-between gap-2 px-3 py-2 dark:text-gray-100">
      <button type="button" className="text-left" aria-expanded={expanded} onClick={onToggle}>
        <span className="font-mono font-semibold">{queue.consumer}</span>
        <span className="ml-2 text-xs text-gray-500 dark:text-gray-400">
          {queue.queueName} → {queue.deadLetterQueueName}
        </span>
      </button>
      <div className="flex items-center gap-3">
        <span className={classNames('text-sm', { 'font-semibold text-red-600 dark:text-red-400': queue.messages > 0 })}>{queue.messages} na DLQ</span>
        <button type="button" className={buttonClass.destructive} disabled={queue.messages === 0} onClick={onRedrive}>
          Redrive
        </button>
      </div>
    </div>
    {expanded && (
      <div className="border-t border-gray-200 p-3 dark:border-gray-700">
        <DeadLetterMessages consumer={queue.consumer} />
      </div>
    )}
  </div>
);

export default QueueItem;
